// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Checkout`
};

const el_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Πληρωμή`
};

const ru_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Оформить заказ`
};

const he_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `לתשלום`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const checkout = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout", locale)
	if (locale === "en") return en_checkout(inputs)
	if (locale === "el") return el_checkout(inputs)
	if (locale === "ru") return ru_checkout(inputs)
	if (locale === "he") return he_checkout(inputs)
	return "checkout"
};